import * as React from 'react';
import { colors } from '../../../index';

const IconAdvisors = ({
  className = '',
  size = '1em',
  color,
  style = {}
}) => {
  const finalStyle = { ...style,
    fill: colors[color],
    color: colors[color]
  };
  return /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 55 55",
    width: size,
    height: size,
    style: finalStyle,
    className: `icon ${className}`
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.462,
    cy: 11.599,
    rx: 2.115,
    ry: 2.109
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 16.923,
    cy: 11.599,
    rx: 2.115,
    ry: 2.109
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.52 15.817c0 2.109 1.42 3.164 3.172 3.164 1.753 0 3.173-1.055 3.173-3.164H9.52z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.712 10.545H25.193C24.182 4.569 18.97 0 12.693 0 5.692 0 0 5.676 0 12.654c0 6.258 4.584 11.454 10.577 12.463v16.007c0 2.908 2.372 5.273 5.288 5.273h7.404v4.505c0 1.615.915 3.005 2.39 3.625a3.862 3.862 0 001.506.309 3.8 3.8 0 002.658-1.097l7.624-7.342h12.265c2.916 0 5.288-2.365 5.288-5.273V15.817c0-2.907-2.372-5.272-5.288-5.272zM2.115 12.654c0-5.815 4.745-10.545 10.577-10.545S23.27 6.839 23.27 12.654c0 5.814-4.745 10.544-10.577 10.544S2.115 18.468 2.115 12.654zm50.77 28.47a3.172 3.172 0 01-3.173 3.164h-13.12l-8.242 7.937a1.68 1.68 0 01-1.869.36 1.79 1.79 0 01-1.096-1.683v-6.614h-9.52a3.172 3.172 0 01-3.173-3.164V25.307c7 0 12.693-5.676 12.693-12.653h24.327a3.172 3.172 0 013.173 3.163v25.307z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.365 18.98h-5.288a3.172 3.172 0 00-3.173 3.164v3.163h2.115v-3.163c0-.582.474-1.055 1.058-1.055h5.288c.584 0 1.058.473 1.058 1.055v4.218c0 .582-.474 1.054-1.058 1.054h-1.057a3.172 3.172 0 00-3.173 3.164v1.054h2.115V30.58c0-.582.474-1.055 1.058-1.055h1.057c1.75 0 3.173-1.42 3.173-3.163v-4.218a3.172 3.172 0 00-3.173-3.163z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 40.192,
    cy: 35.852,
    rx: 2.115,
    ry: 2.109
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.038 29.525H27.5v2.109h-8.462zm0-4.218H31.73v2.109H19.038zm5.289-4.218h7.404v2.109h-7.404zm-5.289 12.654H27.5v2.109h-8.462z"
  }));
};

export default IconAdvisors;